var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import Icon from "../icon/Icon";
import Box from "../box/Box";
import Text from "../text/Text";
import nextId from "react-id-generator";
import ModalPortal from "onnit-ui/lib/modal/ModalPortal";
function Modal(_a) {
    var title = _a.title, onRequestClose = _a.onRequestClose, children = _a.children, rest = __rest(_a, ["title", "onRequestClose", "children"]);
    var uuid = useState(function () { return nextId("oui-modal-"); })[0];
    return (React.createElement(ModalPortal, __assign({}, rest, { uuid: uuid, onRequestClose: onRequestClose }),
        React.createElement(Box, { display: "flex", alignItems: "center", mb: 4 },
            React.createElement(Box, { flex: "1", mr: 4 }, title && (React.createElement(Text, { as: "h2", fontWeight: "bold", fontSize: 5, id: !rest["aria-labelledby"] ? uuid : undefined }, title))),
            onRequestClose && (React.createElement(Icon, { ariaLabel: "Close ".concat(title ? "".concat(title, " ") : null, "Dialog"), size: 24, color: "black", icon: MdClose, tabIndex: 0, onClick: onRequestClose ? onRequestClose : undefined, style: {
                    cursor: "pointer",
                } }))),
        children));
}
export default Modal;
//# sourceMappingURL=Modal.js.map